module.exports = __webpack_public_path__ + "media/images/type-4-f4679e3fd63b6dd6e1205ca9fbd7e464.png";